const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.color = "black";
    tooltipElement.style.width = "auto";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-50%, 0)";
    tooltipElement.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const manufacturerTooltipHandler = (context) => {
  const label = context.tooltip.dataPoints[0].label;
  const colors = context.tooltip.dataPoints[0].dataset.backgroundColor;
  const dataIndex = context.tooltip.dataPoints[0].dataIndex;

  const totalDevices = context.tooltip.dataPoints[0].dataset.totalDevices;
  const deviceLabels = totalDevices[dataIndex];

  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipElement = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const table = tooltipElement.querySelector("table");

    const tableHead = document.createElement("thead");
    const firstRow = document.createElement("tr");
    const colorElement = document.createElement("th");
    colorElement.setAttribute("align", "left");

    const titleElement = document.createElement("span");
    // titleElement.setAttribute("colspan", "2");
    titleElement.textContent = label;

    const span = document.createElement("span");

    span.style.background = colors[dataIndex];
    span.style.borderWidth = "2px";
    span.style.borderRadius = "50%";
    span.style.marginRight = "5px";
    span.style.width = "10px";
    span.style.height = "10px";
    span.style.display = "inline-block";

    colorElement.appendChild(span);
    firstRow.appendChild(colorElement);
    colorElement.appendChild(titleElement);
    tableHead.appendChild(firstRow);

    const tableBody = document.createElement("table");

    deviceLabels.forEach(({ title, percentage, value }, index) => {
      const blockElement = document.createElement("tr");
      const titleElement = document.createElement("td");
      const valueElement = document.createElement("td");

      valueElement.style.textAlign = "right";
      titleElement.textContent = title;
      valueElement.textContent =
        index === 0 ? `${percentage}%(${value})` : value;
      valueElement.style.fontWeight = 500;

      blockElement.appendChild(titleElement);
      blockElement.appendChild(valueElement);

      tableBody.appendChild(blockElement);
    });

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(tableHead);
    table.appendChild(tableBody);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + "px";
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
